// Menu Hover Start 
let items = document.querySelectorAll(".header__inline-menu details");

items.forEach(item => {
  const menu = item.querySelector("ul");

  // Open on mouse enter
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
  });

  // Close when leaving the whole <details> area
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });

  // Extra safety: if mouse leaves the UL itself
  if (menu) {
    menu.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }
});

function initFooterAccordion() {
  if (window.innerWidth <= 767) {
    document.querySelectorAll('.footer-block--menu').forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');

      if (heading && content && !heading.classList.contains('accordion-enabled')) {
        content.style.display = 'none';
        heading.style.cursor = 'pointer';
        heading.classList.add('accordion-enabled');

        heading.addEventListener('click', function toggleAccordion() {
          heading.classList.toggle('active');
          if (content.style.display === 'none' || content.style.display === '') {
            content.style.display = 'block';
            content.style.maxHeight = content.scrollHeight + "px";
          } else {
            content.style.display = 'none';
            content.style.maxHeight = null;
          }
        });
      }
    });
  } else {
    document.querySelectorAll('.footer-block__heading.accordion-enabled').forEach(heading => {
      const content = heading.parentElement.querySelector('.footer-block__details-content');
      heading.classList.remove('active', 'accordion-enabled');
      heading.style.cursor = '';
      heading.replaceWith(heading.cloneNode(true)); // remove old listener
      if (content) {
        content.style.display = 'block';
        content.style.maxHeight = null;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initFooterAccordion);
window.addEventListener('resize', initFooterAccordion);

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".product__accordion details");

  if (accordions.length > 0) {
    // Close all first
    accordions.forEach((acc, i) => acc.removeAttribute("open"));
    // Open only the first
    accordions[0].setAttribute("open", "true");
  }
});

document.addEventListener('click', function(e) {
  if (
    e.target.closest('.klaviyo-close-form') ||
    e.target.closest('.needsclick[aria-label="POPUP Form"]')
  ) {
    setTimeout(function() {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.height = '';
    }, 300);
  }
});

document.querySelectorAll('.footer-block__details-content .list-menu__item').forEach(item => {
  item.addEventListener('click', function(e) {
    if (this.textContent.toLowerCase().includes('withdrawal')) {
      e.preventDefault();
      e.stopPropagation();

      const withdrawalBtn = document.querySelector(
        '.footer-block.grid__item .eu-wbs-button button[aria-label="Open withdrawal form"]'
      );

      if (withdrawalBtn) {
        withdrawalBtn.click();
      } else {
        console.log('Withdrawal form button not found');
      }
    }
  });
});

document.querySelector('.klaviyo-close-form').addEventListener('click', function() {
  document.body.classList.remove('klaviyo-prevent-body-scrolling');
});
